<template>
  <card-modal>
    <template v-slot:header>
      <span class="title-modal-card" v-text="$t('offers.promo_code')" />
      <v-spacer></v-spacer>
      <v-btn icon x-large @click="closeModal()">
        <v-icon x-large color="primary" v-text="'mdi-close'" />
      </v-btn>
    </template>
    <template v-slot:body>
      <v-container fluid pa-0 ma-0 py-1 px-md-5 class="test_green">
        <v-row dense class="test_blue" justify="center" align="center">
          <v-col cols="10" lg="11" class="test_red">
            <v-form
              ref="Form"
              v-model="valid"
              :disabled="$store.getters.isLoading"
            >
              <v-row justify="center" class="test_blue pt-5 mt-5">
                <v-text-field
                  v-model="form.code"
                  :label="$t('general.code')"
                  :rules="[$rules.required]"
                  clearable
                  @click:clear="handleClearIconClick"
                />
              </v-row>
              <span
                style="margin-left: -10px"
                class="subtitle-card-item-component"
                v-text="message"
              />
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </template>
    <template v-slot:actions>
      <v-col cols="12">
        <ButtonSuccess :valid="valid" @click="checkCode()" />
      </v-col>
    </template>
  </card-modal>
</template>

<script>
export default {
  name: "OfferCode",
  data: () => ({
    panel: null,
    valid: false,
    form: new Form({
      store_id: null,
      code: null,
      isApp: "0",
    }),
    options: {
      duration: 1500,
      offset: 0,
      easing: "linear",
    },
  }),
  computed: {
    message: {
      get() {
        return this.$store.getters.checkoutValidation.promoCode.message;
      },
      set(val) {
        return val;
      },
    },
  },
  watch: {
    panel() {
      if (this.panel === 0) {
        setTimeout(() => {
          document
            .getElementById("promoCodeId")
            .scrollIntoView({ behavior: "smooth" });
        }, 500);
      }
    },
    "form.code": function () {
      if (this.form.code == null) {
        this.$store.dispatch("checkout/setValidationPromoCode", {
          status: null,
          message: "",
        });
        this.$store.dispatch("checkout/setOffer", null);
        this.$emit("input", null);
      } else {
        this.$store.dispatch("checkout/setValidationPromoCode", {
          status: true,
          message: this.$t("offers.need_validate_promo_code"),
        });
      }
    },
  },
  mounted() {
    this.form.store_id = this.$store.getters.storeInfo.id;
    this.$store.dispatch("checkout/setValidationPromoCode", {
      status: null,
      message: "",
    });
  },
  methods: {
    closeModal: function () {
      this.$emit("close", false);
    },
    handleClearIconClick() {
      const self = this;
      self.$store.dispatch("checkout/setOffer", null);
      self.$store.dispatch("cart/setLoad");
    },
    checkCode: async function () {
      const self = this;
      self.$store.dispatch("loading/start");
      const { data } = await self.form.post("/app/v2/checkout/offer/check");

      switch (true) {
        case data.status === "False":
          self.$store.dispatch("checkout/setOffer", null);
          self.$emit("input", null);
          if (data.message === "NOT_VALID") {
            self.$store.dispatch("checkout/setValidationPromoCode", {
              status: true,
              message: self.$t("offers.NOT_VALID"),
            });
          } else if (data.message === "ALREADY_USED_CODE") {
            self.$store.dispatch("checkout/setValidationPromoCode", {
              status: true,
              message: self.$t("offers.ALREADY_USED_CODE"),
            });
          } else if (data.message === "MAX_USE_REACHED") {
            self.$store.dispatch("checkout/setValidationPromoCode", {
              status: true,
              message: self.$t("offers.MAX_USE_REACHED"),
            });
          } else if (data.message === "REQUIRED_AUTH") {
            self.$store.dispatch("checkout/setValidationPromoCode", {
              status: true,
              message: self.$t("offers.REQUIRED_AUTH"),
            });
          }
          break;
        case data.status === "Success":
          self.$store.dispatch("checkout/setOffer", {
            ...data.data,
            code: this.form.code,
          });
          self.$store.dispatch("checkout/setValidationPromoCode", {
            status: true,
            message: self.$t("offers.CODE_VALID"),
          });
          self.panel = null;
          self.$emit("input", self.form.code);
          self.$store.dispatch("cart/setLoad");
          if (data.data.is_credit) {
            await this.$store.dispatch("auth/fetchUser");
          }
          break;
        default:
          self.$store.dispatch("checkout/setOffer", null);
          self.$store.dispatch("checkout/setValidationPromoCode", {
            status: null,
            message: self.$t("offers.we_need_promo_code_valid"),
          });
          self.$emit("input", null);
          break;
      }
      self.$store.dispatch("loading/done");
    },
  },
};
</script>
<style lang="scss">
@media only screen and (min-width: 320px) and (max-width: 479px) {
  .expantion .v-expansion-panel-content__wrap {
    padding: 0 !important;
  }
}
</style>
